import axios from 'axios'
import Router from '@/router'
import { Toast, Dialog } from 'vant'
import store from '@/store'
import { getToken } from '@/utils/auth'
console.log(window.location.href)
const config = require('./config')
const baseURL = config[process.env.NODE_ENV].baseUrl

const service = axios.create({
  baseURL,
  // withCredentials: true,
  timeout: 15000
})

service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers.Authorization = `Bearer ${getToken()}`
    }
    return config
  },
  (error) => {
    console.log(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  async (response) => {
    const res = response.data
    if (res.code !== 1) {
      Toast(res.msg)
      if (res.code === 401 || res.code === 403) {
        await store.dispatch('user/resetToken')
        Dialog.confirm({
          title: '提示',
          message: '您还未登录或登录已过期，请重新登录'
        }).then(() => {
          if (['/tutoring', '/tutoring_detail', '/tutoring_order', '/tutoring_next', '/tutoring_cooperation', '/promotion'].indexOf(Router.currentRoute.path) !== -1) {
            Router.push({
              path: `/teacher`,
              query: Router.currentRoute.query
            })
          } else {
            Router.push({
              path: `/login`,
              query: Router.currentRoute.query
            })
          }
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  (error) => {
    console.log('err' + error)
    Toast(error.msg)
    return Promise.reject(error)
  }
)

export default service
